export const widgets = {}